import {Panel} from "primereact/panel";
import {Fieldset} from "primereact/fieldset";
import {useContext, useEffect, useState} from "react";
import {UserService} from "../services/UserService";

import { useSearchParams} from 'react-router';
import {AuthContext} from "../App";

export default function Callback() {
    //const { code, error, status } = useLoaderData();
    const userservice = new UserService();
    const auth = useContext(AuthContext);
    const [searchParams, setSearchParams] = useSearchParams();
    const [newUser, setNewUser] = useState(null);

    // Read parameters
    const code = searchParams.get('code') ?? '';     // string | null
    const error = searchParams.get('error') ?? '';
    const state =  Number(searchParams.get('state'));

    useEffect(() => {
        if(error === '' && code !== '' && code !== null && code !== undefined && state > 0 ){
            userservice.connectSpotifyUserCode(code, state, auth.getAccessToken()).then(result => {
                if(result.status === 200){
                    result.json().then(
                        data => {
                            setNewUser(data);
                        }
                    )
                }
            })
        }

    }, []);

    return (
        <div>
            <h1>Redirect not implemented yet, sorry!</h1>
            <div>If there was an error: { error }</div>
            <div>If nothing is shown, Spotify should be connected and you can go back <a href="https://playlist.laramon.ch">to the playlist generator</a>. The "Save Playlist" Button now has an option to save to that user. </div>
        </div>
    )
}